import React from "react";
import Header from "../../Components/Header/index"
// import Footer from "../../Components/Footer/index"
import DownloadProtectedFile from "../../Components/DownloadProtectedFile/DownloadProtectedFile"
import { setRobotsNoindex } from "../../utility/head";

export default class extends React.Component {
    componentDidMount() {
        AnalyticsSDK.setMetaDataTags("Protected content - Cisco DevNet");

        setRobotsNoindex();
    }

    render() {
        return (
            <div>
                <Header {...this.props}/>
                <DownloadProtectedFile frameUrl={window.location.pathname} fileUrl={window.location.pathname}/>
            </div>
        )
    }
}
